import React from 'react'
import _groupBy from 'lodash/groupBy'
import _map from 'lodash/map'
import _get from 'lodash/get'
import _isEqual from 'lodash/isEqual'
import EmptyBar from '../../../_library/EmptyBar'
import LoadingBar from '../../../_library/LoadingBar'
import { getPerfomanceData } from '../../../../_common/core/http_services'
import { PRE_REGISTRATION_FILTER_TYPE } from '../constants'
import ByNameTable from './ByNameTable'
import ByDateTable from './ByDateTable'

const SECTION = 'pre_registration'

export default class PerformancePreRegistration extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      filterType: PRE_REGISTRATION_FILTER_TYPE.NAME,
      isLoadingPreRegistrationData: true,
    }
  }

  componentDidMount() {
    this.getPreRegistrationData()
    this.getPreRegistrationDataId = setInterval(async () => {
      this.getPreRegistrationData()
    }, 10 * 1000)
  }

  componentWillUnmount() {
    this.isUnmounted = true
    clearInterval(this.getPreRegistrationDataId)
  }

  getPreRegistrationData = async () => {
    const { event } = this.props

    try {
      const data = await getPerfomanceData(event.id, SECTION)
      const preRegistrationData = _map(_get(data, 'pre_registration'), item => ({
        ...item,
        quantity: item.quantity || 0,
      }))

      this.handleResponse(preRegistrationData)
    } catch (err) {
      this.handleResponse(null, err)
    }
  }

  handleResponse = (preRegistrationData, error) => {
    const { isLoadingPreRegistrationData } = this.state

    if (this.isUnmounted || _isEqual(this.initialData, preRegistrationData)) return

    isLoadingPreRegistrationData &&
      this.setState({
        isLoadingPreRegistrationData: false,
      })

    if (error) {
    } else {
      const groupedByDate = _groupBy(preRegistrationData, 'date')
      const groupedByName = _groupBy(preRegistrationData, 'name')

      this.initialData = preRegistrationData
      this.setState({
        preRegistrationData,
        groupedByDate,
        groupedByName,
      })
    }
  }

  onClickTab = type => {
    this.setState({ filterType: type })
  }

  getChildComponent = () => {
    const { event } = this.props
    const { filterType, preRegistrationData, groupedByDate, groupedByName } = this.state

    if (!(preRegistrationData && preRegistrationData.length)) return <EmptyBar />
    switch (filterType) {
      case PRE_REGISTRATION_FILTER_TYPE.NAME:
        return <ByNameTable event={event} data={preRegistrationData} groupedData={groupedByName} />
      case PRE_REGISTRATION_FILTER_TYPE.DATE:
        return <ByDateTable event={event} data={preRegistrationData} groupedData={groupedByDate} />
      default:
        break
    }
  }

  render() {
    const { filterType, isLoadingPreRegistrationData } = this.state

    const tabName = filterType === PRE_REGISTRATION_FILTER_TYPE.NAME ? 'tab-title selected' : 'tab-title'
    const tabDate = filterType === PRE_REGISTRATION_FILTER_TYPE.DATE ? 'tab-title selected' : 'tab-title'

    return isLoadingPreRegistrationData ? (
      <LoadingBar title={`Hold tight! We're getting your event's Pre-Registration...`} />
    ) : (
      <div className="table-background">
        <div className="table-caption">
          <img
            alt="no-data"
            className="section-main-heading"
            src={asset('/resources/images/event/performance/pre-registration-ico.svg')}
          />
          Pre-Registration
        </div>
        <div className="tab-view">
          <div className="tab-header">
            <div className="text-center">
              Group by:
              <div
                aria-hidden
                className={tabName}
                onClick={() => this.onClickTab(PRE_REGISTRATION_FILTER_TYPE.NAME)}
              >
                Name
              </div>
              <div
                aria-hidden
                className={tabDate}
                onClick={() => this.onClickTab(PRE_REGISTRATION_FILTER_TYPE.DATE)}
              >
                Date
              </div>
            </div>
          </div>
        </div>
        {this.getChildComponent()}
      </div>
    )
  }
}
